import { render, staticRenderFns } from "./DiagramTags.vue?vue&type=template&id=75e5c270&"
import script from "./DiagramTags.vue?vue&type=script&lang=ts&"
export * from "./DiagramTags.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramTags.vue?vue&type=style&index=0&id=75e5c270&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports